/*  ========================================================================
    # Components - Feature Admin User Edit User New - Admin
    ========================================================================  */

document.addEventListener('DOMContentLoaded', () => {
  function hideWpDefaultFieldsUserEdit() {
    const classesToHide = [
      '.user-user-login-wrap',
      '.user-first-name-wrap',
      '.user-last-name-wrap',
      '.user-nickname-wrap',
      '.user-email-wrap'
    ];

    classesToHide.forEach(className => {
      const element = document.querySelector(className) ? document.querySelector(className) : null;
      if (element !== null) {
        element.style.display = 'none';
      }
    });
  }

  function hideWpDefaultFieldsUserNew() {
    const classesToHide = [
      'label[for="user_login"]',
      'label[for="email"]',
      'label[for="first_name"]',
      'label[for="last_name"]',
      'label[for="url"]'
    ];

    classesToHide.forEach(className => {
      const element = document.querySelector(className) ? document.querySelector(className) : null;
      if (element !== null) {
        element.closest('tr').style.display = 'none';
      }
    });
  }

  function syncInputsFirstName() {
    const wpInput = document.querySelector('#first_name');
    const acfInput = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_firstname`
    );

    acfInput.addEventListener(
      'input',
      () => {
        wpInput.value = acfInput.value;
      },
      { passive: true }
    );
  }

  function syncInputsLastName() {
    const wpInput = document.querySelector('#last_name');
    const acfInput = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_lastname`
    );

    acfInput.addEventListener(
      'input',
      () => {
        wpInput.value = acfInput.value;
      },
      { passive: true }
    );
  }

  function syncInputsNickname() {
    const wpInput = document.querySelector('#nickname');
    const acfInputFirstName = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_firstname`
    );
    const acfInputLastName = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_lastname`
    );

    acfInputFirstName.addEventListener(
      'input',
      () => {
        wpInput.value = acfInputFirstName.value + ' ' + acfInputLastName.value;
      },
      { passive: true }
    );

    acfInputLastName.addEventListener(
      'input',
      () => {
        wpInput.value = acfInputFirstName.value + ' ' + acfInputLastName.value;
      },
      { passive: true }
    );
  }

  function syncInputsEMail() {
    const wpInput = document.querySelector('#email');
    const acfInput = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_email`
    );
    acfInput.addEventListener(
      'input',
      () => {
        wpInput.value = acfInput.value;
      },
      { passive: true }
    );
  }

  function syncInputsUserName() {
    const wpInput = document.querySelector('#user_login');
    const acfInput = document.querySelector(
      `#acf-field_${this.fieldGroupPrefix}_personal-field_${this.fieldGroupPrefix}_personal_email`
    );
    acfInput.addEventListener(
      'input',
      () => {
        wpInput.value = acfInput.value;
      },
      { passive: true }
    );
  }

  function init() {
    this.isUserEdit =
      document.body.classList.contains('user-edit-php') ||
      document.body.classList.contains('profile-php');
    this.isUserNew = document.body.classList.contains('user-new-php');
    this.fieldGroupPrefix = 'kombauserprofile';
    if (this.isUserEdit) {
      hideWpDefaultFieldsUserEdit();
      syncInputsFirstName();
      syncInputsLastName();
      syncInputsNickname();
      syncInputsEMail();
    } else if (this.isUserNew) {
      hideWpDefaultFieldsUserNew();
      syncInputsFirstName();
      syncInputsLastName();
      syncInputsEMail();
      syncInputsUserName();
    }
  }

  if (typeof acf !== 'undefined') {
    init();
  }
});
